import { Stack, Typography } from "@mui/material";
import { Moneda } from "@/shared/types/moneda";
import { DataTable } from "@/components/data-table";
import { formatNumber } from "@/shared/formats";
import { getMontoItem, getTotalMonto, mapMonedaValues } from "@/features/monetizacion/shared/utils";
import { MontoRequest } from "@/shared/types/monto";
import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";
import { Form, useFormContext } from "@/components/form";

export interface MontoFieldModalFormObjectiveFieldsProps {
    objective: number,
    objectiveFilled?: number,
    emotionalDamage?: boolean,
    monedas: Moneda[],
    allowNegative?: boolean,
    decimalScale?: number,
}

function roundToDecimal(x: number, d: number) {
    const pow10 = Math.pow(10, d);
    return Math.round(x * pow10) / pow10;
}

export default function MontoFieldModalFormObjectiveFields({
    objective,
    objectiveFilled = 0,
    emotionalDamage = false,
    monedas,
    allowNegative,
    decimalScale = 2
}: MontoFieldModalFormObjectiveFieldsProps) {
    const { monedaBase, cotizacion } = useMonetizacion();

    const form = useFormContext();

    return <DataTable>
        <DataTable.Content
            rows={monedas}
            columns={[
                {
                    header: "Moneda",
                    render: moneda => `${moneda.nombre} (${moneda.simbolo})`,
                    width: "auto"
                },
                {
                    header: "Total",
                    render: moneda => formatNumber(roundToDecimal(mapMonedaValues(cotizacion, objective, monedaBase.id, moneda.id), decimalScale)),
                    width: "150px",
                    align: "right"
                },
                {
                    header: "Falta",
                    render: moneda => <form.Subscribe selector={state => state.values as MontoRequest}>
                        {monto => {
                            const localObjective = mapMonedaValues(cotizacion, objective, monedaBase.id, moneda.id);
                            const localObjectiveFilled = mapMonedaValues(cotizacion, objectiveFilled, monedaBase.id, moneda.id);
                            const totalFilled = getTotalMonto(monto, cotizacion, moneda.id) + localObjectiveFilled;
                            const roundedLocalLeft = roundToDecimal(localObjective - totalFilled, decimalScale);
                            const color = (roundedLocalLeft !== 0) ? "error" : (roundedLocalLeft === 0) ? "primary" : undefined;
                            return <Typography variant="inherit" color={emotionalDamage ? color : undefined}>
                                {formatNumber(roundedLocalLeft)}
                            </Typography>
                        }}
                    </form.Subscribe>,
                    width: "150px",
                    align: "right"
                },
                {
                    header: "",
                    render: (moneda, index) => <form.Subscribe selector={state => state.values as MontoRequest}>
                        {monto => <Stack>
                            <Form.MonedaField
                                key={moneda.id}
                                size="small"
                                name={`items[${index}].cantidad`}
                                label={moneda.nombre}
                                monedaId={moneda.id}
                                allowNegative={allowNegative}
                                decimalScale={decimalScale}
                                onValueChange={({ floatValue }) => {
                                    if (floatValue == null) return;
                                    const targetThreashold = Math.abs(Math.pow(10, -decimalScale));
                                    const localObjetive = mapMonedaValues(cotizacion, objective, monedaBase.id, moneda.id);
                                    const localFilled = mapMonedaValues(cotizacion, objectiveFilled, monedaBase.id, moneda.id);

                                    const filledManually = monedas.reduce((t, m) => Number(m.id === moneda.id ? t + floatValue : t + mapMonedaValues(cotizacion, getMontoItem(monto, m.id).cantidad, m.id, moneda.id)), 0);
                                    const left = localObjetive - (filledManually + localFilled);
                                    if (Math.abs(roundToDecimal(left, decimalScale)) < targetThreashold)
                                        form.setFieldValue(`items[${index}].cantidad`, floatValue + left);
                                }}
                            />
                        </Stack>}
                    </form.Subscribe>,
                    width: "250px"
                }
            ]}
        />
    </DataTable>
}